<template>
    <div class="consume_management_wrap">
        <div class="consume_management_top">
            <div class="item_number">
                <div class="time">
                    <el-date-picker :picker-options="pickerOptions"  @change="handleClickSearch" align="right" size="small"
                                    end-placeholder="结束日期" format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" type="daterange" unlink-panels
                                    v-model="time" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                <div class="list">
                    <div class="item" :class="item.platform_id == platform_id ? 'active' : ''" v-for="item in platformTotal" @click="handleClickItem(item)">
                        <div class="number" v-text="item.total > 999 ? '999+' : item.total "></div>
                        <div class="text" v-if="item.platform_detail">{{item.platform_detail.platform_name}}</div>
                    </div>
                </div>
                <img src="https://download.hecoos.com/enlightv/2024-50/38c1f3588398c7c4cd9f0628114831a4.png" alt="">
            </div>
            <div class="item_price">
                <div class="title">核销金额</div>
                <div class="item">
                    <div class="number" v-text="total_amount "></div>
                    <div class="text">以商品金额为准</div>
                </div>
                <img src="https://download.hecoos.com/enlightv/2024-50/0c8730e9e4076b9bb62c4c7491333da0.png" alt="">
            </div>

        </div>
        <div class="consume_management_bottom">
            <div class="total_number" v-if="platform_id">
                <span v-text="platformTotal.find(find => find.platform_id == platform_id) ? platformTotal.find(find => find.platform_id == platform_id).platform_detail.platform_name :''"></span>
                共{{pagination.total}}条记录</div>
            <CustomVxeTable
                    ref="tableRef"
                    class="custom-table"
                    id="wxChatOrderTable"
                    :tableData="tableData"
                    :reduceHeight="reduceHeight"
                    :isShowToolBar="true"
                    :loading="loading"
                    :empty-render="{ name: 'NotData' }"
                    :pagination.sync="pagination"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                    :customConfig="tableCustomConfig">
                <vxe-column field="order_num" title="对应订单编号"  min-width="200" show-overflow></vxe-column>
                <vxe-column field="ticket_name" title="商品名称"  min-width="180" show-overflow>
                    <template #default="{ row }">
                        <span v-if="row.ticket_detail" v-text="row.ticket_detail.ticket_name"></span>
                    </template>
                </vxe-column>
                <vxe-column field="platform_detail" title="购买平台"  min-width="180" show-overflow>
                    <template #default="{ row }">
                        <span v-if="row.platform_detail" v-text="row.platform_detail.platform_name"></span>
                    </template>
                </vxe-column>
                <vxe-column field="pay_user" title="购买人"    min-width="180" show-overflow>
                    <template #default="{ row }">
                        <span v-if="row.pay_user" v-text="row.pay_user.phone"></span>
                    </template>
                </vxe-column>
                <vxe-column field="num" title="核销数量"  min-width="100" show-overflow> </vxe-column>
                <vxe-column field="ticket_code_list" title="核销编号"  min-width="180" show-overflow>
                    <template #default="{ row }">
                        <span v-if="row.ticket_code_list" v-text="row.ticket_code_list.map(map => map.ticket_code).join('，')"></span>
                    </template>
                </vxe-column>
                <vxe-column field="price" title="商品金额"  min-width="180" show-overflow></vxe-column>
                <vxe-column field="created_at" title="核销时间"  min-width="180" show-overflow></vxe-column>
                <vxe-column field="operator_detail" title="核销人"    min-width="180" show-overflow>
                    <template #default="{ row }">
                        <div class="user_head ellipsis" v-if="row.operator_detail" >
                             <img :src="row.operator_detail.header_img ? row.operator_detail.header_img :defaultImg"  alt=""  />
                             <span class="ellipsis"  v-text="row.operator_detail.name"></span>
                         </div>
<!--                        <userDetailPopover>-->
<!--                            <div slot="container">-->
<!--                                <div class="user_head ellipsis" >-->
<!--                                    <img src="https://download.hecoos.com/enlightv/2024-46/e7e5005972b057d954e94f9b0281f0b9.png"  alt=""  />-->
<!--                                    <span class="ellipsis">刘世阳</span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </userDetailPopover>-->
                    </template>
                </vxe-column>
                <template #empty>
                    <div class="custom-table-empty">
                        <div class="custom-table-empty-img"></div>
                        <p class="custom-table-empty-txt">暂无记录</p>
                    </div>
                </template>

            </CustomVxeTable>

        </div>
    </div>
</template>
<script>
import {WxOrderConsumetList, WxConsumeCount} from "@/api/index.js"
import {pagination} from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import userDetailPopover from "@/components/pComponents/userDetailPopover";
import {getNowDate} from "@/utils";


export default {
    name: "wxConsumeManagement",
    components: {
        CustomVxeTable,
        userDetailPopover
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            loading:false,
            tableData:[],
            tableCustomConfig: {
                storage:true,
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "id";
                },
                allowSort: true,
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今日',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '昨日',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            end.setTime(end.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '本周',
                        onClick(picker) {
                            // 设置今天的日期
                            const today = new Date(); // 注意月份是从0开始的，所以9月是8
                            const dayOfWeek = today.getDay();
                            const dayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
                            const start = new Date(today);
                            start.setDate(start.getDate() + dayOffset);
                            const end = new Date(start);
                            end.setDate(end.getDate() + 6);
                            picker.$emit('pick', [ start, end]);
                        }
                    },
                    {
                        text: '上周',
                        onClick(picker) {
                            const today = new Date();
                            const day = today.getDay() || 7; // 将getDay()返回的0（周日）转换为7
                            const start = new Date(today);
                            start.setDate(today.getDate() - day - 6); // 上周一的日期
                            const end = new Date(today);
                            end.setDate(today.getDate() - day); // 上周日的日期
                            picker.$emit('pick', [start, end]);
                        }
                    },

                    {
                        text: '本月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(end.getFullYear(), end.getMonth(), 1);
                            picker.$emit('pick', [start, end]);
                        }
                    },

                ],
            },
            time:[],
            platform_id:'',
            total_amount: "0.00",

            total_count: 0,
            platformTotal:[],
            other_total:0,
            other_price:'',
        };
    },
    mixins: [pagination],
    computed: {
        reduceHeight() {
            return  this.tableData.length ? 336 : 290;
        },
    },
    created() {
        this.time = [getNowDate(),getNowDate()]
    },
    mounted() {
        this.getTableData()
        this.getWxConsumeCount()

    },
    methods: {
        handleClickItem(item){
            this.platform_id = item.platform_id
            this.total_amount =  item.price
            this.pagination.pageNum = 1
            this.getTableData()
        },
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
            this.getWxConsumeCount()
        },
        // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val.pageSize
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        getTableData(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                time:this.time ? this.time.join(' - ') : '',
                platform_id:this.platform_id
            }
            this.loading = true
            WxOrderConsumetList(postData).then(res=> {
                if(res.code === 200) {
                    let {data,total} = res.data
                    this.tableData = data
                    this.pagination.total = total
                }
                this.loading = false
            })
        },
        getWxConsumeCount(){
            let postData = {
                time:this.time ? this.time.join(' - ') : '',
            }

            WxConsumeCount(postData).then(res=> {
                if(res.code === 200) {
                    this.total_amount = res.data.priceTotal //核销金额
                    // 被删除的就是其他
                    let other_total  = 0
                    let other_price  = 0
                    let otherList = res.data.platformTotal.filter(find => find.platform_detail.is_del == 1)
                    otherList.forEach((item)=>{
                        other_total  = Number(other_total ) + Number(item.total)
                        other_price  = Number(other_price) + Number(item.price)
                    })
                    other_price = other_price.toFixed(2)
                    console.log(other_price);
                    let platformTotal = res.data.platformTotal.filter(find => find.platform_detail.is_del == 0)
                    let data1 = [{platform_id:'',total:res.data.ticketTotal,price:res.data.priceTotal,platform_detail:{platform_name:'全部'}}]
                    let data2 = [{platform_id:'other',total:other_total,price:other_price,platform_detail:{platform_name:'其他'}}]
                    this.platformTotal = [...data1,...platformTotal,...data2]
                    if(this.platformTotal.findIndex(find => find.platform_id == this.platform_id) < 0){
                        this.platform_id = ''
                        this.handleClickSearch()
                    }
                }

            })
        }

    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/wechat.scss";
</style>
